/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_ParqInputs */

const en_us2_profile_row_parq = /** @type {(inputs: Profile_Row_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readiness questionnaire (PAR-Q)`)
};

const pt_br2_profile_row_parq = /** @type {(inputs: Profile_Row_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionário de prontidão (PAR-Q)`)
};

const es_419_profile_row_parq = /** @type {(inputs: Profile_Row_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuestionario de aptitud (PAR-Q)`)
};

const pt_pt2_profile_row_parq = /** @type {(inputs: Profile_Row_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionário de prontidão (PAR-Q)`)
};

const fr_fr2_profile_row_parq = /** @type {(inputs: Profile_Row_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionnaire d'aptitude (PAR-Q)`)
};

const de_de2_profile_row_parq = /** @type {(inputs: Profile_Row_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheitsfragebogen (PAR-Q)`)
};

const it_it2_profile_row_parq = /** @type {(inputs: Profile_Row_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionario di idoneità (PAR-Q)`)
};

/**
* | output |
* | --- |
* | "Readiness questionnaire (PAR-Q)" |
*
* @param {Profile_Row_ParqInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_parq = /** @type {((inputs?: Profile_Row_ParqInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_ParqInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_parq(inputs)
	if (locale === "es-419") return es_419_profile_row_parq(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_parq(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_parq(inputs)
	if (locale === "de-DE") return de_de2_profile_row_parq(inputs)
	if (locale === "it-IT") return it_it2_profile_row_parq(inputs)
	return en_us2_profile_row_parq(inputs)
});
export { profile_row_parq as "profile.row_parq" }